import React from "react";
import { useDispatch } from "react-redux";
import { downloadProductTagImportSampleCsv } from "../store/prodcutSlice";
import { Col, Form, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import AsyncSelect from "react-select/async";
import DropZone from "../../../share-components/upload/dropzone";
import Typography from "@material-ui/core/Typography";
import {baseUrlAsync} from "../../../utils/api";


const customStyles = {
    control: base => ({
        ...base,
        minHeight: 50,
        border: 'none',
    }),
    menuPortal: base => ({ ...base, zIndex: 1000 })
};


export default function ImportProductGradeTagForm(props) {

    const {
        dialog,
        size = 'lg',
        productState,
        handleSubmit,
        onSubmitForm,
        handleFileInputChange,
        submitBtnSaveRef,
        importProductTrigger,
        setIsSeller,
        isSeller,
        setValue,
        buttonDisable,
        uploadFile,
        errors,
        productImportErrors,
        successProductImport,
        notImportedCount,
        closeDialog
    } = props;

    const dispatch = useDispatch();

    const closeImportProductTagDialog = () => {
        closeDialog();
    }

    const getABCReportLink = () => {
        if (window.location.origin == 'https://mp.mygoddiva.com') {

            return "https://admin.shopify.com/store/goddivalondon/analytics/reports/341344631?ql=FROM+inventory++SHOW+ending_inventory_units%2C+ending_inventory_value%2C++++ending_inventory_retail_value++WHERE+inventory_is_tracked+%3D+true+AND+product_vendor+IN+(%27Goddiva+Plus%27%2C++++%27Goddiva%27%2C+%27Danaya%27%2C+%27Cosmochic%27%2C+%27City+Goddess%27)++GROUP+BY+product_title%2C+product_variant_title%2C+product_variant_sku%2C++++product_variant_abc_grade+WITH+GROUP_TOTALS%2C+TOTALS++SINCE+startOfDay(-30d)+UNTIL+today++ORDER+BY+ending_inventory_value__product_title_totals+DESC%2C++++ending_inventory_value__product_title_product_variant_title_totals+DESC%2C++++ending_inventory_value__product_title_product_variant_title_product_variant_sku_totals++++DESC%2C+ending_inventory_value+DESC%2C+product_title+ASC%2C+product_variant_title+ASC%2C++++product_variant_sku+ASC%2C+product_variant_abc_grade+ASC++LIMIT+1000VISUALIZE+ending_inventory_value+TYPE+single_stacked_bar";
        }
        return "https://admin.shopify.com/store/goddivatest/analytics/reports/331383168?ql=FROM+inventory%0A++SHOW+ending_inventory_units%2C+ending_inventory_value%2C%0A++++ending_inventory_retail_value%0A++WHERE+inventory_is_tracked+%3D+true+AND+product_vendor+IN+%28%27Goddiva+Plus%27%2C%0A++++%27Goddiva%27%2C+%27Danaya%27%2C+%27Cosmochic%27%2C+%27City+Goddess%27%29%0A++GROUP+BY+product_title%2C+product_variant_title%2C+product_variant_sku%2C%0A++++product_variant_abc_grade+WITH+GROUP_TOTALS%2C+TOTALS%0A++DURING+last_month%0A++ORDER+BY+ending_inventory_value__product_title_totals+DESC%2C%0A++++ending_inventory_value__product_title_product_variant_title_totals+DESC%2C%0A++++ending_inventory_value__product_title_product_variant_title_product_variant_sku_totals%0A++++DESC%2C+ending_inventory_value+DESC%2C+product_title+ASC%2C+product_variant_title+ASC%2C%0A++++product_variant_sku+ASC%2C+product_variant_abc_grade+ASC%0A++LIMIT+1000%0AVISUALIZE+ending_inventory_value+TYPE+single_stacked_bar";
    }

    return (
        <div className="flex flex-col modal-lg">
            <Modal size={size} {...productState.importProductGradeTagDialog.props} toggle={() => closeImportProductTagDialog()}>
                <ModalHeader toggle={() => {
                    closeImportProductTagDialog()
                }}>
                    Import Products Grade
                </ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleSubmit(onSubmitForm)}>
                        <Row className="mt-3 mb-3">
                            <Col md={12} className="mt-4">
                                <div className="product-box">
                                    <div className="product-img pt-3 pb-3">
                                        <DropZone
                                            extension={".csv, .xlsx, .xls"}
                                            onChangeFile={handleFileInputChange}></DropZone>
                                    </div>

                                    {uploadFile ? (
                                        <Typography>File: {`${uploadFile[0].name}`}{' '}</Typography>
                                    ) : (
                                        ''
                                    )}
                                </div>
                            </Col>
                            <Col md={9}></Col>
                            <Col md={3} className="mt-4">
                                <button disabled={buttonDisable} ref={submitBtnSaveRef} onClick={() => {
                                }} className="btn btn-success btn-block">
                                    {buttonDisable ? ( // Show the spinner if loading state is true
                                        <i className="fa fa-spinner fa-spin fa-lg spinner" />
                                    ) : (
                                        'Import' // Show the regular text if loading state is false
                                    )}
                                </button>
                            </Col>
                            <Col md={3}></Col>
                        </Row>

                        {(successProductImport) ?
                            <Row>
                                <Col md={12}>
                                    <h6 className="text-success">{successProductImport} product's grade and tag updated successfully</h6>
                                </Col>
                            </Row>
                            : <></>
                        }

                        {(productImportErrors && productImportErrors.length > 0) ?
                            <Row>
                                <Col md={12}>
                                    <h6 className="text-danger">{notImportedCount} product's grade and tag could not be updated due to following errors:</h6>
                                    <ul>
                                        {productImportErrors.map((error, index) => (
                                            <li key={index} className="text-danger">{error}</li>
                                        ))}
                                    </ul>
                                </Col>
                            </Row>
                            : <></>
                        }
                    </Form>

                    <ModalFooter className="mt-2">
                        <a href={getABCReportLink()} target="_blank" style={{ color: "black", fontWeight: "normal" }}>
                            <i className="fa fa-download mr-1" aria-hidden="true"></i>
                            Download ABC Analysis File
                        </a>
                    </ModalFooter>
                </ModalBody>
            </Modal>
        </div>
    )
}